module.exports = __webpack_public_path__ + "6d07be835c9b92d56c1a4a2a89db3ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ad/images/ad.png
// module id = 391
// module chunks = 0 1 2 3